import classnames from "classnames";
import classes from "../../../styles/Resources.module.scss";
import Banner from "../../../components/common/Banner/Banner";
import BannerType from "../../../global/banner-type";
import resources from "../../../assets/images/resources.png";
import { whatsAppData, faqChannel } from "../../../global/constant";
import ContentSection from "../../../components/common/ContentSection/ContentSection";

const WhatsApp = () => {
  return (
    <div className={classnames(classes.main_content)}>
      <div className={classnames(classes.bannerSection)}>
        <Banner
          type={BannerType.SINGLE_IMAGE_BANNER}
          title="WhatsApp"
          description="A WhatsApp campaign refers to a marketing strategy that leverages the WhatsApp messaging platform to send targeted messages, promotional content, or important information to a group of recipients."
          image={resources}
          maxWidth={214}
          className={classes.containerWidth}
        />
      </div>
      <ContentSection
        heading="Features and application of WhatsApp Channel"
        data={whatsAppData}
        faqData={faqChannel}
        isIndexingRequired={false}
      />
    </div>
  );
};

export default WhatsApp;
